import { useCockpitContext, useCockpitDialog } from '@/pages/cockpit/useCockpit'

import { ShareDialog } from './ShareDialog'

/**
 * The share dialog wired to the cockpit.
 *
 * The header opens it by setting `?dialog=share`; whoever owns the tab that
 * is open renders this one line and it appears. It reads the template, the
 * project name and both permissions from `useCockpitContext`, so opening the
 * dialog costs one request (the access list) rather than four.
 *
 * `folderName` is "Ohne Projekt" when the form is in none — that sentence
 * does not belong in a subtitle, so it is dropped rather than printed.
 */
export function CockpitShareDialog() {
  const cockpit = useCockpitContext()
  const { dialog, close } = useCockpitDialog()

  return (
    <ShareDialog
      open={dialog === 'share'}
      onOpenChange={(open) => {
        if (!open) close()
      }}
      templateId={cockpit.templateId}
      templateTitle={cockpit.template?.title}
      folderName={cockpit.folder ? cockpit.folderName : undefined}
      canManage={cockpit.canManage}
      canWrite={cockpit.canWrite}
    />
  )
}
